import React from 'react'
import ModalComponent from '../../../../core/common/modal/ModalComponent'
import Select, { StylesConfig } from "react-select";


type props={
    show: boolean,
    handleClose:() => void,
}
const ExistingContactModal = ({show,handleClose}:props) => {

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
          color: state.isFocused ? "#fff" : "#000",
          "&:hover": {
            backgroundColor: "rgba(177, 31, 40, 1)",
          },
        }),
      };

  return (
    <ModalComponent
    modalTitle='Contacts'
    isVisible={show}
    cancelButton="Cancel"
    onClose={handleClose}
    saveButton='Save'
    className="p-2"

  >
    <>
      <div className="col-md-12">
        <label className="col-form-label">
        Existing Contacts<span className="text-danger"> *</span>
        </label>
        <Select
                    styles={customStyles}
                    className="select"
                    // options={usersLookup?.result?.businessUnits?.map((option: any) => ({
                    //   label: option?.name,
                    //   value: option?.id
                    // }))}
                    // value={
                    //   formik.values?.businessUnit?.id
                    //     ? {
                    //       value: formik.values?.businessUnit?.id,
                    //       label: formik.values?.businessUnit?.title || '',
                    //     }
                    //     : null
                    // }
                    // isDisabled={viewOnly}
                    // onChange={(selectedOption: any) => {
                    //   formik.setFieldValue('businessUnit.id', selectedOption.value);
                    //   formik.setFieldValue('businessUnit.title', selectedOption.label);
                    // }}
                  />
      </div>
    </>

  </ModalComponent>
  )
}

export default ExistingContactModal